import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { H2 } from '../styled/typography/typography'
import FlexAlignCenter from '../styled/FlexAlignCenter'
import BtnC from '../styled/buttons/BtnC'
import BtnA from '../styled/buttons/BtnA'

export const ModalTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 30px;
  border-bottom: 1px solid ${props => props.theme.rockLine};
  background: ${props => props.theme.cardBackground};
`

export const ModalBottom = styled.div`
  padding: 15px 30px 30px 30px;
  background: ${props => props.theme.footerBackground};
`

export const EditModalHeader = ({ title, onCancel, onSave, canCancel, canSave}) => (
  <ModalTop>
    <H2>{title}</H2>

    <FlexAlignCenter spaced>
      <BtnC fixedWidth disabled={!canCancel} onClick={onCancel}>
        Cancel
      </BtnC>
      <BtnA fixedWidth disabled={!canSave} onClick={onSave}>
        Save
      </BtnA>
    </FlexAlignCenter>
  </ModalTop>
)

export default class Modal extends Component {

  constructor (props) {
    super(props)
    this.onEscapeBound = this.onEscape.bind(this)
  }

  componentDidMount () {
    if (this.props.lockBodyScroll) {
      document.body.classList.add('no-scroll')
    }

    document.addEventListener('keyup', this.onEscapeBound)
  }

  componentWillUnmount () {
    if (this.props.lockBodyScroll) {
      document.body.classList.remove('no-scroll')
    }

    document.removeEventListener('keyup', this.onEscapeBound)
  }

  onEscape (e) {
    // ESC key
    if (e.keyCode === 27 && this.props.allowEscape) {
      this.props.closeCallback()
    }
  }

  render () {
    const style = {
      height: !this.props.autoHeight
        ? this.props.percentHeight ? `${this.props.percentHeight}%` : `${this.props.height}px`
        : 'auto',
      width: `${this.props.width}px`,
      transform: 'translate(-50%, -50%)',
      background: '#fff'
    }

    const overlayStyle = {}

    overlayStyle.background = this.props.background ? this.props.background : 'rgba(38, 55, 70, 0.45)'

    overlayStyle.opacity = this.props.opacity ? this.props.opacity : '1'

    if (this.props.overlayHeight) {
      overlayStyle.height = this.props.overlayHeight
    }

    if (this.props.allowOuterScroll) {
      overlayStyle.overflowY = 'scroll'
    }

    if (this.props.allowOverflow) {
      style.overflow = 'visible'
    }

    if (this.props.allowInnerScroll) {
      style.overflowY = 'auto'
    }

    if (this.props.maxPercentHeight) {
      delete style.height
      style.maxHeight = `${this.props.maxPercentHeight}%`
    }

    if (this.props.top) {
      style.top = `${this.props.top}%`
    }

    if (this.props.topPx) {
      style.top = `${this.props.topPx}px`
    }

    if (this.props.borderRadius) {
      style.borderRadius = `${this.props.borderRadius}`
    }

    if (this.props.boxShadow) {
      style.boxShadow = `${this.props.boxShadow}`
    }

    if (this.props.position) {
      style.position = `${this.props.position}`
    }

    return (
      <div className='qw-modal'>
        <div
          className='modal-overlay'
          style={overlayStyle}
          onClick={this.props.allowCloseOnExternalClick ? this.props.closeCallback : null}
        >
          <div
            className='modal-contents'
            style={style}>
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

Modal.defaultProps = {
  allowEscape: true,
  allowCloseOnExternalClick: true,
  lockBodyScroll: true,
  autoHeight: false,
  allowInnerScroll: false,
  allowOverflow: false
}

Modal.propTypes = {
  top: PropTypes.number,
  percentHeight: PropTypes.number,
  maxPercentHeight: PropTypes.number,
  autoHeight: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
  background: PropTypes.string,
  opacity: PropTypes.string,
  borderRadius: PropTypes.string,
  boxShadow: PropTypes.string,
  children: PropTypes.object,
  closeCallback: PropTypes.func,
  allowEscape: PropTypes.bool,
  lockBodyScroll: PropTypes.bool,
  allowInnerScroll: PropTypes.bool,
  allowCloseOnExternalClick: PropTypes.bool,
  allowOverflow: PropTypes.bool,
  topPx: PropTypes.number,
  overlayHeight: PropTypes.string,
  position: PropTypes.string,
  allowOuterScroll: PropTypes.bool
}
